import { combineReducers, configureStore } from '@reduxjs/toolkit';
import themeConfigSlice from './themeConfigSlice';
import attendanceSlice from './slice/AttendanceSlice';
import scheduleSlice from '../redux/schedule/slices';

const rootReducer = combineReducers({
    themeConfig: themeConfigSlice,
    attendance: attendanceSlice,
    schedule: scheduleSlice,
})

export default configureStore({
    reducer: rootReducer,
})

export type IRootState = ReturnType<typeof rootReducer>
